
<div class="MenuDropdown" v-click-outside="handleClickOutside">
    <div class="MenuDropdown-Trigger" ref="trigger" @click="toggle">
        <slot name="trigger" :isOpen="isOpen" :openUpward="openUpward">
            <button class="MenuDropdown-Button">
                <slot name="button-content" :isOpen="isOpen" :openUpward="openUpward">
                    <span>{{ title }}</span>
                    <i
                        :class="[
                            openUpward ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line',
                            { 'is-open': isOpen },
                        ]"
                    ></i>
                </slot>
            </button>
        </slot>
    </div>
    <div
        ref="content"
        class="MenuDropdown-Content"
        :class="{ 'is-open': isOpen, 'open-upward': openUpward, 'is-morphing': isMorphing }"
    >
        <div
            class="MenuDropdown-List"
            :class="{ 'items-at-top': itemsAtTop, 'open-upward': openUpward }"
        >
            <div
                v-for="(item, index) in sortedItems"
                :key="index"
                class="MenuDropdown-Item"
                :class="{
                    'is-clickable': item.to || item.href || item.action || item.click,
                    'is-active': item.to && $route.path === item.to,
                }"
                :style="{ '--item-index': index }"
                @click="handleItemClick(item)"
            >
                <i v-if="item.icon" :class="item.icon" class="MenuDropdown-ItemIcon"></i>
                <span class="MenuDropdown-ItemLabel">{{ item.label }}</span>
                <span
                    v-if="item.tooltip"
                    class="MenuDropdown-InfoIcon"
                    tabindex="0"
                    @click.stop
                >
                    <i class="ri-information-line"></i>
                    <span class="MenuDropdown-Tooltip" :class="tooltipPosition">
                        <slot name="tooltip" :item="item" :index="index">
                            {{ item.tooltip }}
                        </slot>
                    </span>
                </span>
                <i
                    v-if="(item.to || item.href) && item.showArrow !== false"
                    class="ri-arrow-right-s-line MenuDropdown-ItemArrow"
                ></i>
                <span v-if="item.shortcut" class="MenuDropdown-ItemShortcut">{{
                    item.shortcut
                }}</span>
            </div>
            <slot name="items"></slot>
        </div>
    </div>
    <MorphingGhost
        :fromElement="triggerElement"
        :toElement="contentElement"
        :isOpen="isOpen"
        :zIndex="8"
        :useRelative="useRelative"
        @animation-complete="onAnimationComplete"
    />
</div>
